import * as Sentry from '@sentry/react';
import { ignoredSentryErrors } from '../utils/sentry-utility';

function makeSilentTransport(options) {
  const transport = Sentry.makeFetchTransport(options);
  return {
    ...transport,
    send: (...args) => transport.send(...args).catch(() => ({ statusCode: 0 })),
  };
}

if (process.env.NODE_ENV === 'production') {
  try {
    Sentry.init({
      dsn: 'https://d17e0862d013461f8a35cab4e272314b@o1037722.ingest.sentry.io/6005829',
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.50,
      ignoreErrors: ignoredSentryErrors,
      transport: makeSilentTransport,
    });
  } catch (e) {
    try {
      navigator.sendBeacon(
        '/widget-metrics/error',
        new Blob(
          [JSON.stringify({ widget_type: 'sentry_init', error: { message: e.message, stack: e.stack } })],
          { type: 'application/json' },
        ),
      );
    } catch {
      // Silently discard — never leak errors into partner consoles
    }
  }
}
